import { NativeStackScreenProps } from '@react-navigation/native-stack';
import { NavigationStacks, Screens, Stacks } from 'components/Navigation/types';
import * as React from 'react';
import { ErrorBoundaryAppFallback } from 'components/ErrorBoundaryAppFallback';

type Props = NativeStackScreenProps<
  NavigationStacks[Stacks.ROOT],
  Screens.RootError
>;

export const TabError: React.FC<Props> = () => {
  return <ErrorBoundaryAppFallback />;
};
